import { Button, Modal, Table, App, Divider } from "antd"
import { SearchByAccountResponseModel, SearchSingleFunction } from "../../../../model/searchInvoiceModels";
import './Index.css'
import { Content } from "antd/es/layout/layout";
import { useCallback, useState } from "react";
import localStorageManagement from "../../../../helper/services/localStorageServices";
import { InboxOutlined, UserDeleteOutlined } from "@ant-design/icons";
import useLoginForm from "./LoginForm";
import DateRangeSearchInvoice from "./DatePicker";
import { RangePickerProps } from "antd/es/date-picker";
import AccountInformation from "./AccountInformation";
import { ColumnsType } from "antd/es/table";
import Toolbar from "../../../UI/Search/Single/SearchResult/Toolbar";
import useSearchInvoiceService from "../../../../helper/services/searchInvoiceServices";
import vi_VN from "../../../../data/locale";
const Account: React.FC = () => {
    const app = App.useApp();
    const user = localStorageManagement.getUser();
    const [token, setToken] = useState<string | undefined>(user?.token)
    const [dateRangeFilter, setDateRangeFilter] = useState<{ tu_ngay: string | undefined, den_ngay: string | undefined } | null>(null);
    const [tableData, setTableData] = useState<SearchByAccountResponseModel[]>([]);
    const searchService = useSearchInvoiceService();
    const loginCallback = useCallback((token: string) => {
        setToken(token);
        app.message.success("Đăng nhập thành công");
    }, [])
    const loginForm = useLoginForm(loginCallback);

    const downloadXml = (masothue: string, sobaomat: string, sohoadon: number) => {
        searchService
            .getXml(masothue, sobaomat)
            .then((response) => {
                if (!response) return;
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = response;
                a.download = "Invoice_" + masothue + "_" + sobaomat + ".zip";
                a.click();
                window.URL.revokeObjectURL(response);
                document.body.removeChild(a);
            })

    }
    const searchSingleFunction: SearchSingleFunction = useCallback((taxCode, securityCode) => {
        return searchService.getPdfInvoice(taxCode, securityCode, false)
    }, [])
    const viewPdf = (masothue: string, sobaomat: string, sohoadon: number) => {
        searchService.getPdfInvoice(masothue, sobaomat, false)
            .then((response) => {
                Modal.success({
                    title: `Hóa đơn số ${sohoadon}`,
                    content: (
                        <>
                            <Toolbar searchFunction={searchSingleFunction} taxCode={masothue} securityCode={sobaomat} />
                            <iframe id="invoicePdfView"
                                style={{ width: "100%", aspectRatio: "1/ 1.414" }}
                                src={response ?? undefined}
                            ></iframe>

                        </>

                    ),
                    width: "30%",
                    closable: true,
                    centered: true,
                })
            })

    }
    const dataColumns: ColumnsType<SearchByAccountResponseModel> = [
        {
            dataIndex: "inv_invoiceSeries",
            key: "inv_invoiceSeries",
            title: "Ký hiệu",
            align: "center"
        },
        {
            dataIndex: "inv_invoiceNumber",
            key: "inv_invoiceNumber",
            title: "Số hóa đơn",
            align: "center",
            render: (value, record, index) => {
                return Number.parseInt(value);
            }
        },
        {
            dataIndex: "inv_invoiceIssuedDate",
            key: "inv_invoiceIssuedDate",
            title: "Ngày hóa đơn",
            align: "center",
            render: (value, record, index) => {
                return value.split("T")[0]
            }
        },
        {
            dataIndex: "inv_TotalAmount",
            key: "inv_TotalAmount",
            title: "Tổng tiền",
            align: "center",
            render: (value, record, index) => {
                return new Intl.NumberFormat('vi-VI', { style: 'currency', currency: 'VND' }).format(value);
            }
        },
        {
            dataIndex: "mau_hd",
            key: "mau_hd",
            title: "Mẫu số",
            align: "center"
        },
        {
            dataIndex: "button",
            key: "button",
            title: "",
            align: "center",
            render: (value, record, index) => {
                return (<>
                    <Button onClick={() => viewPdf(user?.mst as string, record.sobaomat as string, Number.parseInt(record.inv_invoiceNumber as string))}>PDF</Button>
                    <Divider type="vertical"></Divider>
                    <Button onClick={() => downloadXml(user?.mst as string, record.sobaomat as string, Number.parseInt(record.inv_invoiceNumber as string))}>XML</Button>
                </>)
            }
        }
    ]
    const showLoginForm = () => {
        Modal.info({
            title: "Đăng nhập tài khoản tra cứu",
            content: (<loginForm.UI></loginForm.UI>),
            okText: "Đăng nhập",
            closable: true,
            onOk: () => {
                loginForm.formRef.submit();
            }
        })
    }
    const getEmptyTextOverlay = () => {

        if (token && localStorageManagement.isValidToken()) {
            return (
                <>
                    <InboxOutlined className="table-local-icon" /><br />
                    <span>Không tìm thấy dữ liệu, vui lòng thử tìm kiếm lại</span>
                </>
            )
        }
        return (
            <>
                <UserDeleteOutlined className="table-local-icon" size={1000} /><br />
                <span>Vui lòng <Button onClick={showLoginForm}>Đăng nhập</Button> để tra cứu theo tài khoản</span>
            </>
        )
    }
    const dateRangePickerProps: RangePickerProps = {
        onChange: (value, format) => {
            setDateRangeFilter({ tu_ngay: value?.[0]?.toJSON(), den_ngay: value?.[1]?.toJSON() })
        },
        locale: vi_VN,
        showNow: true,
        allowEmpty: [false, false]
    }
    const onSearchClick = () => {
        if (!dateRangeFilter || Object.values(dateRangeFilter).some((val) => !val)) {
            app.message.error("Vui lòng chọn khoảng thời gian cần tra cứu");
            return;
        }
        searchService
            .getInvoiceByAccount(dateRangeFilter.tu_ngay as string, dateRangeFilter.den_ngay as string)
            .then((response) => setTableData(response))
    }
    return (
        <Content className="search-by-account-area">
            <h1>Tra cứu theo tài khoản <AccountInformation isVisible={Boolean(token) && localStorageManagement.isValidToken()}></AccountInformation></h1>
            <DateRangeSearchInvoice
                datePickerProps={dateRangePickerProps}
                isVisible={Boolean(token)}
                onSearchClick={onSearchClick} />

            <Table className="search-by-account-table"
                columns={dataColumns}
                locale={{
                    emptyText() {
                        return getEmptyTextOverlay();
                    },
                }}
                rowKey={(record) => record.inv_InvoiceAuth_id}
                scroll={{ y: "35vh" }}
                dataSource={tableData}
            >
            </Table>
        </Content>
    )
}
export default Account